export default __webpack_public_path__ + "static/media/graph.2c8ff4c8.svg";